import React from 'react';
import Answer from './Answer/Answer';
import './Question.css';

function Question({question, questionIndex, questionsQuantity, onAnswerClick}) {
    const handleAnswerClick = (answer) => {
        if (!question) return;
        if (onAnswerClick) onAnswerClick(question.id, answer);
    };

    const renderDots = () => {
        let dots = [];
        for (let i = 0; i < questionsQuantity; i++) {
            const selected = i === questionIndex;
            dots.push(<div key={`question_dot-${i}`} className={`question_dot${selected ? ' selected' : ''}`}></div>);
        }
        return dots;
    };

    const renderAnswers = () => {
        return question.answers.map((answer) => (
            <Answer key={`answer-${question.id}-${answer.id}`} answer={answer} onClick={handleAnswerClick}/>
        ));
    };

    return (
        <div className='question'>
            <div className='question_title'>{question.title || 'Sin título'}</div>
            {questionIndex && questionsQuantity ? <div className='question_dots'>{renderDots()}</div> : undefined}
            <div className='question_answers'>{renderAnswers()}</div>
        </div>
    );
}

export default Question;